<template>
  <app-layout title="Dashboard">
    <template v-slot:sidenav></template>

    <div class="grid grid-cols-5 h-[calc(100vh-66px)]">
      <div class="h-[calc(100vh-66px)]">
        <!-- The Whatsapp component emits the event when a chat is clicked -->
        <Whatsapp @unread="handleUnreadItem" @startchat="startnewchat" @contactSelected="newcontactSelected" :receivedValue="sharedValue" ref="whatsAppRef" ></Whatsapp>
      </div>

      <div class="col-span-3 h-[calc(100vh-66px)]">
        <!-- Conditional rendering based on whether a chat is clicked or not -->
        <WhatsappScreen
          @messageSent="handleSendMessage"
          v-if="chatSelected"
          :receivedValue="sharedValue"
          ref="whatsAppScreenRef" 
        ></WhatsappScreen>
        <Default v-else></Default>
      </div>

      <WhatsappSide @contactsaved="handleconversationlist":receivedValue="sharedValue"></WhatsappSide>
    </div>
  </app-layout>
</template>

<script>
import { ref, onMounted,nextTick } from 'vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import Whatsapp from "./Whatsapp.vue";
import WhatsappScreen from "./WhatsappScreen.vue";
import Default from "./Default.vue";
import WhatsappSide from "./WhatsappSide.vue";

export default {
  components: {
    AppLayout,
    Whatsapp,
    WhatsappScreen,
    WhatsappSide,
    Default,
  },
  
  setup() {
    const whatsAppRef = ref(null); 
    const whatsAppScreenRef= ref(null); // Correctly define the ref

    // Shared state and data
    const chatSelected = ref(false);
    const sharedValue = ref('');

    // Methods
    const handleUnreadItem = async (phone_no) => {
      sharedValue.value = phone_no;
      chatSelected.value = true;
      console.log("Chat selected with phone_no:", sharedValue.value);

      // Ensure DOM updates and the component is rendered
      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };
      
    const startnewchat = async (phoneNumber) => {
      sharedValue.value = phoneNumber;
      chatSelected.value = true;
      console.log("Chat selected with phone number:", sharedValue.value);
      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };

    const newcontactSelected =  async (contact) => {
      console.log("Contact selected:", contact);
      sharedValue.value = contact;
    
      chatSelected.value = true;
      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };

    const handleSendMessage = () => {
      if (whatsAppRef.value) {
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppRef is not available.");
      }
    };
    const handleconversationlist = () => {
      if (whatsAppRef.value) {
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppRef is not available.");
      }
    };
    // Ensuring that the ref is available after the component is mounted
    onMounted(() => {
      if (!whatsAppRef.value) {
        console.error("whatsAppRef is null on mounted");
      }
    });

    return {
      whatsAppRef,
      whatsAppScreenRef, // Return the ref so you can use it
      chatSelected,
      sharedValue,
      handleUnreadItem,
      startnewchat,
      newcontactSelected,
      handleSendMessage,
      handleconversationlist
    };
  },
};
</script>

<style></style>
